import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import StarIcon from '@material-ui/icons/StarBorder';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import Icon from '@material-ui/core/Icon';
import Paper from '@material-ui/core/Paper';
import Divider from '@material-ui/core/Divider';
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';
import BarChartIcon from '@mui/icons-material/BarChart';
import GroupsIcon from '@mui/icons-material/Groups';
import ScienceIcon from '@mui/icons-material/Science';
import JoinFullIcon from '@mui/icons-material/JoinFull';
import SpeedIcon from '@mui/icons-material/Speed';
import BuildIcon from '@mui/icons-material/Build';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Stack from '@mui/material/Stack';
import Hidden from '@mui/material/Hidden';

import Header from './Header';
import Footer from './Footer';
import RequestDemo from './RequestDemo';
import FreeTrial from './FreeTrial';
import ContactForm from './ContactForm';

import StreamLocatorLogo from './../../StreamLocator_logo.png';
import SMSLiveLogo from './../../smsliveLogo.png';
import StreamLocatorLogoGrey from './../../StreamLocator_logoGrey.png';
import StreamLocatorLogoLight from './../../StreamLocator_logoLight.png';
import SMSLiveLogoGrey from './../../smsliveLogoGrey.png';
import SMSLiveLogoLight from './../../smsliveLogoLight.png';
import PBPLogoGrey from './../../pbp_logo_200Grey.png';
import PBPLogoLight from './../../pbp_logo_200Light.png';
import EmergeLogoGrey from './../../emergeLogoGrey.png';
import EmergeLogoLight from './../../emerge-logoLight.png';
import EmergeLogo from './../../emerge-logo.png';
import ConnectionsLogos from './../../ConnectionsLogos.png';
import Base13Logo from './../../Color logo - no background.png';
import Base13Graphic from './../../Color graphic - no background.png';
import ShopifyLogo from './../../shopify_logo_white.png';
// import Base13Logo from './../../Black logo - no background.png';

const useStyles = makeStyles((theme) => ({
  '@global': {
    ul: {
      margin: 0,
      padding: 0,
      listStyle: 'none',
    },
  },
  button: {
    margin: theme.spacing(1),
  },
  divider: {
    margin: theme.spacing(3),
  },
  answer: {
    padding: theme.spacing(2, 0, 0),
  },
  image: {
    flex: 1,
    padding: 2,
    width: 100,
    height: 100,
    resizeMode: 'contain'
  },
  paper: {
    width: 102,
    height: 102,
    borderRadius:16,
    margin: 'auto',
    justifyContent: 'center',
  },
  link: {
    margin: theme.spacing(1, 1.5),
    textDecoration: 'none',
    color: 'white',
    underline: 'none',
    hover: {
    "&:hover": {
      color: '#cbd5e1'
      }
    }
  },
  logo: {
    width: 165,
    height: 48,
  },
  heroContent: {
    padding: theme.spacing(8, 0, 6),
    //backgroundColor: "#cccccc",
  },
  cardHeader: {
    backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[700],
  },
  cardPricing: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'baseline',
    marginBottom: theme.spacing(2),
  },
  cardPricing: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'baseline',
    marginBottom: theme.spacing(1),
  },
}));

const themeDark = createMuiTheme({
  palette: {
    background: {
      default: "#495C83"
    },
    text: {
      secondary: "#ffffff"
    }
  }
});


export default function ShopifyData() {
  const classes = useStyles();

  return (
    <React.Fragment >
    <MuiThemeProvider theme={themeDark}>
      <CssBaseline />


      <Container maxWidth="lg" component="main" className={classes.heroContent} style={{color:"#37474f"}} >
      {/*<Box
          display="flex"
          alignItems="left"
          justifyContent="left"
          style={{padding:5}}
          >
          <Link href="/"><img className={classes.logo} src={Base13Logo}/></Link>
          </Box>*/}

        <Hidden smDown><Box style={{padding:50}}></Box></Hidden>
        <Hidden mdUp><Box style={{padding:0}}></Box></Hidden>
        <Grid container direction={'row'} alignItems="flex" style={{padding:10}}>
        <Grid
            item
            container
            direction="column"
            alignItems="flex-start"
            justify="center" xs={12} sm={12} md={8} lg={8}
            >
        {/*<Box style={{padding:60}}></Box>*/}
        <Hidden smDown>
        <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 2, md: 4 }}
            display="flex"
            alignItems="center"
            justifyContent="center"
            style={{padding:0}}
            >
              <img className={classes.streamLocatorLogo} style={{ maxWidth: 200 }} src={Base13Logo}/>
              <img className={classes.dwdblogoPadding} />
              <img className={classes.shopifyLogo} style={{ maxWidth: 150 }} src={ShopifyLogo}/>
        </Stack>
        </Hidden>
        <Hidden mdUp>
        <Stack
            direction={{ xs: 'row', sm: 'row' }}
            spacing={{ xs: 1, sm: 2, md: 4 }}
            display="flex-start"
            // alignItems="center"
            justifyContent="center"
            style={{padding:5}}
            >
              <img className={classes.streamLocatorLogo} style={{ maxWidth: 150 }} src={Base13Logo}/>
              <img className={classes.dwdblogoPadding} />
              <img className={classes.shopifyLogo} style={{ maxWidth:125 }} src={ShopifyLogo}/>
        </Stack>
        </Hidden>

        <Typography component="h1" variant="h3" style={{ padding:5,  fontStyle: 'bolded', fontFamily: 'Arial'}} align="left" justify="center" color="textSecondary" >
          Your Shopify store is unique and so are your data needs
        </Typography>
        <Hidden mdUp>
        <Box style={{padding:10}}></Box>
        </Hidden>
        <Hidden smDown>
        <Box style={{padding:20}}></Box>
        <Typography component="h1" variant="h6" style={{ fontStyle: 'bolded', fontFamily: 'Arial'}} align="left" justify="center" color="textSecondary" >
          Your business needs don't fit in a box so why should your data solutions. Get easily accessible and manageable data that fits your company's unique requirements.
          Base13 Labs sets up your data stack, gets you the insights you need, and helps you take control of your data.
        </Typography>
        </Hidden>
        <Box style={{padding:10}}></Box>
        <Box
        display="flex"
        alignItems="left"
        justifyContent="left"
        style={{padding:0}}
        >
        <JoinFullIcon style={{color:'#0284c7', width:40, height:40}} fontsize="small"/>
        <Typography variant="h6" style={{ fontFamily: 'Arial', padding:5 }} align="left" color="textSecondary" component="p4">
         <Box sx={{ fontWeight: 'bold', paddingRight:3}} display='inline' >Join 100s of Sources</Box>
        </Typography>
        </Box>
        <Box
        display="flex"
        alignItems="left"
        justifyContent="left"
        style={{padding:0}}
        >
        <AllInclusiveIcon style={{color:'#0284c7', width:40, height:40}} fontsize="small"/>
        <Typography variant="h6" style={{ fontFamily: 'Arial', paddingLeft:5}} align="left" color="textSecondary" component="h4">
         <Box sx={{ fontWeight: 'bold', paddingRight:3 }} display='inline' >Scales with your growth</Box>
        </Typography>
        </Box>
        <Box
        display="flex"
        alignItems="left"
        justifyContent="left"
        style={{padding:0}}
        >
        <BuildIcon style={{color:'#0284c7', width:40, height:40}} fontsize="small"/>
        <Typography variant="h6" style={{ fontFamily: 'Arial', padding:5 }} align="left" color="textSecondary" component="p4">
         <Box sx={{ fontWeight: 'bold', paddingRight:3}} display='inline' >Customizable to your needs</Box>
        </Typography>
        </Box>
        <Box
        display="flex"
        alignItems="left"
        justifyContent="left"
        style={{padding:0}}
        >
        <SpeedIcon style={{color:'#0284c7', width:40, height:40}} fontsize="small"/>
        <Typography variant="h6" style={{ fontFamily: 'Arial', padding:5 }} align="left" color="textSecondary" component="h4">
         <Box sx={{ fontWeight: 'bold', paddingRight:3}} display='inline' >Data at the speed of your decision making</Box>
        </Typography>
        </Box>
        {/*<Box style={{padding:10}}></Box>*/}
        <Box
        display="flex"
        alignItems="left"
        justifyContent="left"
        style={{padding:0}}
        >
        <ScienceIcon style={{color:'#0284c7', width:40, height:40}} fontsize="small"/>
        <Typography variant="h6" style={{ fontFamily: 'Arial', padding:5 }} align="left" color="textSecondary" component="p4">
         <Box sx={{ fontWeight: 'bold', paddingRight:3}} display='inline' >Build in predictive capabilities</Box>
        </Typography>
        </Box>
        <Box style={{padding:20}}></Box>

          <Hidden mdUp>
            <Grid container alignItems="flex-end" >
            <Grid xs={12} sm={12} md={12} lg={12} alignItems="flex-end">
            <Typography component="h5" variant="h5" style={{ fontStyle: 'bolded', fontFamily: 'Arial'}} align="center" justify="center" color="textSecondary" >
              Businesses with an effective data strategy use Base13 Labs
            </Typography>

            <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 2, md: 4 }}
            display="flex"
            alignItems="center"
            justifyContent="center"
            style={{padding:20}}
            >q
              <Hidden smDown>
              <img className={classes.streamLocatorLogo} style={{ maxWidth: 150 }} src={StreamLocatorLogoLight}/>
              <img className={classes.dwdblogoPadding} />
              <img className={classes.smsLiveLogo} style={{ maxWidth: 175 }} src={PBPLogoLight}/>
              <img className={classes.dwdblogoPadding} />
              </Hidden>
              <img className={classes.smsLiveLogo} style={{ maxWidth: 125 }} src={EmergeLogoLight}/>
              <img className={classes.dwdblogoPadding} />
              <img className={classes.smsLiveLogo} style={{ maxWidth: 125 }} src={SMSLiveLogoLight}/>

            </Stack>
            </Grid>
            </Grid>
            </Hidden>

        </Grid>
        <Grid item
            container
            alignItems="flex"
            justify="center"
            xs={12} sm={12} md={4} lg={4}
            // paddingRight={25}
            >
            <Paper elevation={3}>
        <Box
                display="block"
                alignItems="center"
                justifyContent="center"
                style={{padding:30}}
              >
                <ContactForm />
              </Box>
              </Paper >
        </Grid>
        </Grid>


       <Hidden smDown>
       <Box style={{padding:50}}></Box>
        <Grid container alignItems="flex-end" >
        <Grid xs={12} sm={12} md={12} lg={12} alignItems="flex-end">
        <Typography variant="h5" style={{ fontFamily: 'Arial'}} align="center" component="h5" justify="center" color="textSecondary" >
        {/*<Typography variant="h6" style={{ fontFamily: 'Arial', padding:5 }} align="center" color="textPrimary" component="h4">*/}
          Businesses with an effective data strategy use Base13 Labs
        </Typography>

        <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={{ xs: 1, sm: 2, md: 4 }}
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{padding:20}}
        >
          <img className={classes.streamLocatorLogo} style={{ maxWidth: 150 }} src={StreamLocatorLogoLight}/>
          <img className={classes.dwdblogoPadding} />
          <img className={classes.smsLiveLogo} style={{ maxWidth: 175 }} src={PBPLogoLight}/>
          <img className={classes.dwdblogoPadding} />
          <img className={classes.smsLiveLogo} style={{ maxWidth: 125 }} src={EmergeLogoLight}/>
          <img className={classes.dwdblogoPadding} />
          <img className={classes.smsLiveLogo} style={{ maxWidth: 125 }} src={SMSLiveLogoLight}/>

        </Stack>
        </Grid>
        </Grid>




        <Box style={{padding:50}}></Box>
        </Hidden>

      </Container>
       </MuiThemeProvider>

    </React.Fragment>
  );
}
